<ng-container
  *ngIf="
    !(invitationsLoaded$ | async) ||
      (!(installationDetailsStore.loaded$ | async) && (installationDetailsStore.loading$ | async));
    else loadedEl
  "
>
  <app-panel data-at-building-manager-card [expanded]="true">
    <app-panel-header>{{
      '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.TITLE' | translate
    }}</app-panel-header>
    <app-panel-content class="flex flex-col gap-[8px]">
      <vi-loader
        main
        data-at-loader
        message="{{ '+GENERAL.LOADING_DATA' | translate }}"
        [isLoading]="true"
      ></vi-loader>
    </app-panel-content>
  </app-panel>
</ng-container>

<ng-template #loadedEl>
  <app-panel data-at-building-manager-card [expandable]="false" [expanded]="true">
    <app-panel-header>{{
      '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.TITLE' | translate
    }}</app-panel-header>

    <app-panel-content class="flex flex-col gap-[8px]">
      <div class="manager-role flex flex-col gap-[8px]">
        <div class="label" data-at-operator-label>
          {{ '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.OPERATOR' | translate }}
          <span
            class="invitation-status"
            *ngIf="getIsRoleAssigneeOtherThanAccepted(InvitationAccessLevel.Operator)"
            >{{ getIsRoleAssigneeOtherThanAccepted(InvitationAccessLevel.Operator) }}</span
          >
        </div>
        <div class="email-container" data-at-operator-value>
          <ng-container
            *ngIf="
              getRoleAssigneeEmail(InvitationAccessLevel.Operator) as email;
              else roleEmailNotDefined
            "
            ><span class="value"
              >{{
                !!(getRoleAssigneeCompanyName(InvitationAccessLevel.Operator) | async)
                  ? (getRoleAssigneeCompanyName(InvitationAccessLevel.Operator) | async)
                  : email
              }}
            </span></ng-container
          >
        </div>
      </div>
      <div class="manager-role flex flex-col gap-[8px]">
        <div class="label" data-at-service-contractor-label>
          {{ '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.SERVICE_CONTRACTOR' | translate }}
          <span
            class="invitation-status"
            *ngIf="getIsRoleAssigneeOtherThanAccepted(InvitationAccessLevel.ServiceContractor)"
            >{{ getIsRoleAssigneeOtherThanAccepted(InvitationAccessLevel.ServiceContractor) }}</span
          >
        </div>
        <div class="email-container" data-at-service-contractor-value>
          <ng-container
            *ngIf="
              getRoleAssigneeEmail(InvitationAccessLevel.ServiceContractor) as email;
              else roleEmailNotDefined
            "
            ><span class="value">{{
              !!(getRoleAssigneeCompanyName(InvitationAccessLevel.ServiceContractor) | async)
                ? (getRoleAssigneeCompanyName(InvitationAccessLevel.ServiceContractor) | async)
                : email
            }}</span></ng-container
          >
        </div>
      </div>

      <ng-template #roleEmailNotDefined
        ><span class="value no-value">{{
          '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.ROLE_NOT_DEFINED' | translate
        }}</span></ng-template
      >
    </app-panel-content>
    <app-panel-content class="flex flex-col gap-[16px]">
      <button
        data-at-building-manager-card-edit-roles-btn
        mat-stroked-button
        color="accent"
        gtm="onOpen"
        gtmAction="Edit roles modal"
        gtmCategory="buildingManagerCard"
        (click)="openRoleManagementModal()"
      >
        {{ '+INSTALLATIONS.INSTALLATION.BUILDING_MANAGER_CARD.EDIT_ROLES_BTN' | translate }}
      </button>
    </app-panel-content>
  </app-panel>
</ng-template>
